import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import Grid from "@material-ui/core/Grid";
import {makeStyles} from "@material-ui/core/styles";
import ProducaoView from "./ProducaoView";
import {
    getConcluidosPorData, getEnviadosPorData,
    getEstacoesTrabalho,
    getOperadoresLogados,
    getPneusNaCasa, getPneusProduzidosHoje,
    getPneusRecebidosHoje, getPneusRecusadosReprovadosHoje,
    getPneusSaidosHoje, getRecebidosPorData, getRecusadosEnviadosPorData, getRecusadosReprovadosPorData
} from "../../../actions/i4Actions";
import {changeFilter} from "../../../actions/FilterActions";


const useStyles = makeStyles(theme => ({
    mainGrid:{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center'

    },

    dashboardSection: {
        // padding: "5px"
    },
    sectionTitle: {
        marginBottom: theme.spacing(1) * 4,
        marginTop: theme.spacing(1) * 4
    },
    marginTop: {
        marginTop: theme.spacing(1) * 4
    },
    marginBottom: {
        marginBottom: theme.spacing(1) * 5,
    },
    marginBottomCharts: {
        margin: theme.spacing(1) * 3,
    },
    marginRight: {
        paddingRight: theme.spacing(1) * 2
    },
    progress: {
        margin: theme.spacing(1) * 2,
    },
}));

const today = new Date();

const PainelTVProducaoSolTipler = ( props ) => {
    const classes = useStyles();

    const dispatch = useDispatch();


    useEffect( () => {

            dispatch(changeFilter({ "periodMin": today.toISOString().substring(0, 8)+'01T00:00:00' }));
            dispatch(changeFilter({ "periodMax": today.toISOString().substring(0, 8)+today.getDate().toString().padStart(2,'0')+'T23:59:59' }));

            dispatch(getEstacoesTrabalho());

            dispatch(getPneusNaCasa());
            dispatch(getPneusRecebidosHoje());
            dispatch(getPneusSaidosHoje());
            dispatch(getPneusProduzidosHoje());
            dispatch(getPneusRecusadosReprovadosHoje());

            dispatch(getRecebidosPorData());
            dispatch(getEnviadosPorData());
            dispatch(getConcluidosPorData());
            dispatch(getRecusadosReprovadosPorData());
            props.setTitulo("PRODUÇÃO - HOJE")

    }, [props.contador]);


    return (
        <React.Fragment>
           <ProducaoView/>
        </React.Fragment>
    )

}
export default (PainelTVProducaoSolTipler);


